 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		21: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		21: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"7a22a0b4853bcac6afeb244d98629966aa3bc7c1","2":"34cbdb7dce72501c23ae13e6c7f43d0152dbe699","3":"ecccab4fa2fe522b4ecd2af7052ef2e97f019a34","4":"framework","5":"b33248341d0a03ca7ecb0980d1547955d5551485","6":"94550a87af5daf25741c212fc7db0e766361a019","7":"dad739f4fadc88078ae156f01e421375556fae00","8":"a8f95c35f81d084e9f7b2597aa5aee1f913e0a48","9":"fffed5baac77de3bde01cc36943f0b769a5beac6","11":"19bdef2133b297aaea511437deea1be02419a346","12":"296d40b85b3cc2b72cc62726c387ec0bd8c64dd3","13":"6564192b96c84fc7ab700cc1bca9beb1ed2b0d6b","14":"66e4c39919229f513fddaa72c3841952aa1bfce4","15":"88682331","16":"8940c012ed3d06ad8de032f405fa0134ec155993","17":"a0984feefbbeaed32a8e51ab799f378041b4fd37","18":"a5985b4268f34c5dd750100ab166c0db3e8d03ac","19":"e496bb7597216b30a065f0f34257fcd48d228c7d","20":"f6be765342124f39c26c42bf5a71ffb99cd28d66","23":"component---cache-caches-gatsby-plugin-offline-app-shell-js","24":"component---src-pages-404-js","25":"component---src-pages-compare-unit-id-js","26":"component---src-pages-compare-unit-js","27":"component---src-pages-development-commercial-id-js","28":"component---src-pages-development-commercial-js","29":"component---src-pages-development-details-id-js","30":"component---src-pages-development-details-js","31":"component---src-pages-development-future-developments-id-js","32":"component---src-pages-development-future-developments-js","33":"component---src-pages-development-hospitalities-id-js","34":"component---src-pages-development-hospitalities-js","35":"component---src-pages-development-industrial-id-js","36":"component---src-pages-development-industrial-js","37":"component---src-pages-development-office-id-js","38":"component---src-pages-development-office-js","39":"component---src-pages-development-residential-id-js","40":"component---src-pages-development-residential-js","41":"component---src-pages-experiment-id-js","42":"component---src-pages-experiment-js","43":"component---src-pages-forgot-password-id-js","44":"component---src-pages-forgot-password-js","45":"component---src-pages-login-id-js","46":"component---src-pages-login-js","47":"component---src-pages-profile-id-js","48":"component---src-pages-profile-js","49":"component---src-pages-register-id-js","50":"component---src-pages-register-js","51":"component---src-pages-search-result-id-js","52":"component---src-pages-search-result-js","53":"component---src-pages-socialmedia-id-js","54":"component---src-pages-socialmedia-js","55":"component---src-pages-subscribe-id-js","56":"component---src-pages-subscribe-js","57":"component---src-pages-thankyou-js","58":"component---src-templates-access-details-js","59":"component---src-templates-development-details-js","60":"component---src-templates-facilities-details-js","61":"component---src-templates-news-details-amp-js","62":"component---src-templates-news-details-js","63":"component---src-templates-news-landing-js","64":"component---src-templates-our-partners-details-js","65":"component---src-templates-pages-js","66":"component---src-templates-sub-page-js","67":"component---src-templates-tnc-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"296e8a49a25df2c44830","2":"c10cbe95be2148514832","3":"75e31aa6b9d8e3f27bbf","4":"d5d8a48f993ae9e13f36","5":"188aa9be0cca656d41bf","6":"8f5fb35091bc8b6b413c","7":"a02dc326b992dcb0eef1","8":"0497da31489e0695f03a","9":"3a3a346b8a7b5800fc8f","10":"0c58961ae7340873f91a","11":"ddbec9233a2849521454","12":"eed6ddcd149d2649d910","13":"95ec4e33c627a78329de","14":"552b595781b3485b4d53","15":"0f9f5003865f7fb19e5a","16":"a05edd24ed8f6ee9aa88","17":"3f741d0ab89d05238513","18":"75be0761bf692e1419e6","19":"fa3f778cb8301b152fea","20":"e397c67676312cf224de","23":"c376a5029f00f93a10af","24":"f614f4d6c9c6c7185bd1","25":"10349e073f9111a9d530","26":"5c7eefd140e3a97f7fc7","27":"de72395828cddf764cfa","28":"7f4143b985684d479436","29":"429dc0bb19432f2c64b4","30":"80c1ee6cac2e2da94ee9","31":"9599eadf31eb4cbbe41b","32":"b0c8e9158d849df3d9e9","33":"8f760693e2c99e3fb918","34":"29ee919937c82dc34053","35":"717064ed6a7a8981668c","36":"01817b1d9c98399bc43d","37":"192a90240241892d6965","38":"099ad639959adddfefaa","39":"f8208807c76c4b1638cf","40":"d7a66993a7c8df667b01","41":"dac986f9590a38a94925","42":"d2833334da6ebcc7baab","43":"9d3440bdbb3446745bf0","44":"eb1d87df687214d97e67","45":"4f2fda57a0a8cc3c0650","46":"faa0144f28e54a9dd442","47":"6952854038e68e6a1315","48":"159c45d127e8c47374d8","49":"2da3e268cb3b5301a570","50":"d77de7f9460145c46d2d","51":"8729f4c9e7a0e2f560c8","52":"79a32d204303a3b34b8e","53":"5c79c70d39f4f6a748de","54":"ee15be1641cb53f601c1","55":"0a97986ac242ac635471","56":"e54a406b180143685b8b","57":"1ad7d25a8e2a47a52a7f","58":"0fba97ae7781d8fadf87","59":"c8a466de1f53b4e48940","60":"15707ab8ad95dacb9fcd","61":"4c8f65887a46933aaae1","62":"518b4342028622b6b573","63":"ee11c8038290b409dffe","64":"95476402454770acb34c","65":"e5afdad587459a1839a8","66":"7154803a5df8579ccd35","67":"272f10a39f9b6425f27c","69":"f22258adcd5103992396"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"7a22a0b4853bcac6afeb244d98629966aa3bc7c1","2":"34cbdb7dce72501c23ae13e6c7f43d0152dbe699","3":"ecccab4fa2fe522b4ecd2af7052ef2e97f019a34","4":"framework","5":"b33248341d0a03ca7ecb0980d1547955d5551485","6":"94550a87af5daf25741c212fc7db0e766361a019","7":"dad739f4fadc88078ae156f01e421375556fae00","8":"a8f95c35f81d084e9f7b2597aa5aee1f913e0a48","9":"fffed5baac77de3bde01cc36943f0b769a5beac6","11":"19bdef2133b297aaea511437deea1be02419a346","12":"296d40b85b3cc2b72cc62726c387ec0bd8c64dd3","13":"6564192b96c84fc7ab700cc1bca9beb1ed2b0d6b","14":"66e4c39919229f513fddaa72c3841952aa1bfce4","15":"88682331","16":"8940c012ed3d06ad8de032f405fa0134ec155993","17":"a0984feefbbeaed32a8e51ab799f378041b4fd37","18":"a5985b4268f34c5dd750100ab166c0db3e8d03ac","19":"e496bb7597216b30a065f0f34257fcd48d228c7d","20":"f6be765342124f39c26c42bf5a71ffb99cd28d66","23":"component---cache-caches-gatsby-plugin-offline-app-shell-js","24":"component---src-pages-404-js","25":"component---src-pages-compare-unit-id-js","26":"component---src-pages-compare-unit-js","27":"component---src-pages-development-commercial-id-js","28":"component---src-pages-development-commercial-js","29":"component---src-pages-development-details-id-js","30":"component---src-pages-development-details-js","31":"component---src-pages-development-future-developments-id-js","32":"component---src-pages-development-future-developments-js","33":"component---src-pages-development-hospitalities-id-js","34":"component---src-pages-development-hospitalities-js","35":"component---src-pages-development-industrial-id-js","36":"component---src-pages-development-industrial-js","37":"component---src-pages-development-office-id-js","38":"component---src-pages-development-office-js","39":"component---src-pages-development-residential-id-js","40":"component---src-pages-development-residential-js","41":"component---src-pages-experiment-id-js","42":"component---src-pages-experiment-js","43":"component---src-pages-forgot-password-id-js","44":"component---src-pages-forgot-password-js","45":"component---src-pages-login-id-js","46":"component---src-pages-login-js","47":"component---src-pages-profile-id-js","48":"component---src-pages-profile-js","49":"component---src-pages-register-id-js","50":"component---src-pages-register-js","51":"component---src-pages-search-result-id-js","52":"component---src-pages-search-result-js","53":"component---src-pages-socialmedia-id-js","54":"component---src-pages-socialmedia-js","55":"component---src-pages-subscribe-id-js","56":"component---src-pages-subscribe-js","57":"component---src-pages-thankyou-js","58":"component---src-templates-access-details-js","59":"component---src-templates-development-details-js","60":"component---src-templates-facilities-details-js","61":"component---src-templates-news-details-amp-js","62":"component---src-templates-news-details-js","63":"component---src-templates-news-landing-js","64":"component---src-templates-our-partners-details-js","65":"component---src-templates-pages-js","66":"component---src-templates-sub-page-js","67":"component---src-templates-tnc-js"}[chunkId]||chunkId) + "." + {"0":"9f1f0ab4f74ecbf418c8","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
